import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<div><!></div>`);

export default function Card_content($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var div = root();

	$.attribute_effect(div, ($0) => ({ 'data-slot': 'card-content', class: $0, ...restProps }), [() => cn("px-6", $$props.class)]);

	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.bind_this(div, ($$value) => ref($$value), () => ref());
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC1jb250ZW50LnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuXHRpbXBvcnQgdHlwZSB7IEhUTUxBdHRyaWJ1dGVzIH0gZnJvbSBcInN2ZWx0ZS9lbGVtZW50c1wiO1xuXHRpbXBvcnQgeyBjbiwgdHlwZSBXaXRoRWxlbWVudFJlZiB9IGZyb20gXCIkbGliL3V0aWxzLmpzXCI7XG5cblx0bGV0IHtcblx0XHRyZWYgPSAkYmluZGFibGUobnVsbCksXG5cdFx0Y2xhc3M6IGNsYXNzTmFtZSxcblx0XHRjaGlsZHJlbixcblx0XHQuLi5yZXN0UHJvcHNcblx0fTogV2l0aEVsZW1lbnRSZWY8SFRNTEF0dHJpYnV0ZXM8SFRNTERpdkVsZW1lbnQ+PiA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG5cbjxkaXYgYmluZDp0aGlzPXtyZWZ9IGRhdGEtc2xvdD1cImNhcmQtY29udGVudFwiIGNsYXNzPXtjbihcInB4LTZcIiwgY2xhc3NOYW1lKX0gey4uLnJlc3RQcm9wc30+XG5cdHtAcmVuZGVyIGNoaWxkcmVuPy4oKX1cbjwvZGl2PlxuIl0sIm1hcHBpbmdzIjoiOztTQUVVLEVBQUUsUUFBNkIsZUFBZTs7Ozt3REFGeEQsQ0FBQzs7O0tBS0MsR0FBRyw4QkFBYSxJQUFJO0VBR2pCLFNBQVM7Ozs7Ozs7Ozs7OytFQUlrRSxTQUFTLFlBQXBDLEVBQUUsQ0FBQyxNQUFNOzs7Ozs7K0JBQTlDLEdBQUcsaUJBQUgsR0FBRzs7O0FBRnBCLENBQUMifQ==